import init from '../../../js/init';

const DEFAULT_REFRESH_INTERVAL = 5 * 60 * 1000; // 5 min in ms. How often data needs to be refreshed.

const name = 'openweather-widget';
const selector = '.openweather-widget';
const iconSelector = `${selector}__icon`;
const textSelector = `${selector}__text`;


class OpenWeatherWidget {
  constructor(root, api, refreshInterval) {
    const icon = root.querySelector(iconSelector);
    const text = root.querySelector(textSelector);

    this.iconElem = icon;
    this.textElem = text;
    this.refreshInterval = +refreshInterval || DEFAULT_REFRESH_INTERVAL;
    this.api = api;

    this.initItems();
    this.setItemsInterval();
  }

  async initItems() {
    const remoteData = await this.getData();
    this.iconElem.innerHTML = remoteData.icon;
    this.textElem.innerHTML = remoteData.text;
  }

  async getData() {
    const res = await fetch(this.api);
    return (await res.json()).data;
  }

  setItemsInterval() {
    setInterval(this.initItems.bind(this), this.refreshInterval);
  }
}

init(Drupal, name, selector, (root, data) => {
  new OpenWeatherWidget(root, data.api, data.refreshInterval);
});
